//export const API_URL = "http://localhost:1337";
export const API_URL = "https://api.v1.verifieddna.com";
export const TOKEN_KEY = "strapi-jwt-token";
export const WEB_URL = "https://verifieddna.com";
//export const WEB_URL = "http://localhost:3000";
